import {bindable, BindingEngine, containerless, customElement, inject} from 'aurelia-framework';
import {UserClient} from "../api/user-client";

@customElement('sio-action')
@containerless()
@inject(BindingEngine, UserClient)
export class ActionClass {
    @bindable config;
    @bindable action;
    @bindable context = {};

    @bindable onBeforeClick = undefined; // Hook: Called after successful action execution
    @bindable onAfterSuccess = undefined; // Hook: Called after successful action execution
    @bindable redirectAfterDelete = false; // Hook: Called after successful action execution

    showWithoutPermission = false;
    subscription;

    constructor(bindingEngine, userClient) {
        this.bindingEngine = bindingEngine;
        this.userClient = userClient;

        this.showWithoutPermission = this.userClient.showWithoutPermission;

        // Observe changes in contentLocale
        this.subscription = this.bindingEngine.propertyObserver(this.userClient, 'showWithoutPermission')
            .subscribe((showWithoutPermission) => {
                this.showWithoutPermission = showWithoutPermission;
            });
    }

    dispose() {
        if (this.subscription) {
            this.subscription.dispose();
        }
    }
}
